// extracted by mini-css-extract-plugin
export var actionButton = "_i6-t";
export var buttonContainer = "_i6-0";
export var buttonContainer2 = "_i6-1";
export var buttonSection = "_i6-2";
export var details = "_i6-3";
export var dropdownItem = "_i6-5";
export var dropdownItemsContainer = "_i6-4";
export var fileInput = "_i6-r";
export var headerButton = "_i6-6";
export var icon = "_i6-7";
export var input = "_i6-8";
export var macroListItem = "_i6-9";
export var mainContent = "_i6-a";
export var microText = "_i6-b";
export var modal = "_i6-w";
export var optionsButton = "_i6-c";
export var paperclip = "_i6-s";
export var pillContent = "_i6-d";
export var preview = "_i6-e";
export var preview2 = "_i6-f";
export var quillEditor = "_i6-q";
export var selectedMacro = "_i6-g";
export var sidebar = "_i6-h";
export var sidebarHeader = "_i6-j";
export var sidebarList = "_i6-i";
export var sidebarListItem = "_i6-k";
export var sidebarSearch = "_i6-l";
export var snoozeDurationWrapper = "_i6-v";
export var statusPillContainer = "_i6-m";
export var tagsContainer = "_i6-n";
export var unselectedMacro = "_i6-o";
export var variable = "_i6-u";
export var wrapper = "_i6-p";